import JobsOne from "./JobsOne";
import JobsTwo from './JobsTwo'

export default function Jobs() {
  return (
    <main className="bg-gray-900">
     <JobsOne/>
     <JobsTwo/>
    </main>
  );
}
